import request from '@/utils/request'
import {Base64} from "js-base64";

export async function findExamList(data) {
    if (data.typeList.includes('112')) {
        data.typeList = data.typeList.concat(['701'])
    }

    const r1 = await request({
        url: `/system/examPaper/studentExam?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        method: 'post',
        data
    })

    const r2 = await request({
        url: `/system/examPaper/percentageStatistics?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        method: 'post',
        data
    })
    return [r1, r2]
}

export function examStatisticsApi(typeList) {
    if (typeList.includes('112')) {
        typeList = typeList.concat(['701'])
    }
    return request({
        url: `/system/examPaper/percentageStatistics?pageNum=1&pageSize=50`,
        method: 'post',
        data:{
            typeList
        }
    })
}
// 准备页面数据获取
export function findPaperInfo(data) {
    return request({
        url: `/system/exam/prepareExam`,
        method: 'get',
        params: data
    })
}

// 生成考试记录
export function makeRecordId(data) {
    return request({
        url: `/system/exam/preBeginExam`,
        method: 'get',
        params: data
    })
}

export async function findExamInfo(data) {
    const r1 = await request({
        url: `/system/exam/beginExam`,
        method: 'get',
        params: data
    })
    if (r1.data?.questionList?.length) { // 全部解码
        r1.data.questionList.forEach(qa => {
            if (qa.solution) {
                qa.solution = Base64.decode(qa.solution)
            }
            (qa.subQuestionList || []).forEach(sub => {
                if (sub.solution) {
                    sub.solution = Base64.decode(sub.solution)
                }
            })
        })
    }
    return r1
}

// 获取题目在线编辑url
export function findTopicUrl(data) {
    return request({
        url: `/system/exam/getESheetFileUrl`,
        method: 'get',
        params: data
    })
}

// E表--重新做题-清除文件
export function clearExcelUrl(data) {
    return request({
        url: `/system/exam/reDoQue`,
        method: 'get',
        params: data
    })
}

// 查询考试记录
export function findExamRecord(data) {
    return request({
        url: `/system/examPaper/studentExam/exam`,
        method: 'post',
        data
    })
}

// 查询考试解析列表
export async function findExamAnalysis(data) {
    const r1 = await request({
        url: `/system/examPaper/answer/record`,
        method: 'post',
        data
    })
    if (r1.data?.examQuestionsVo?.length) {
        r1.data.examQuestionsVo.forEach(qa => {
            if (qa.solution) {
                qa.solution = Base64.decode(qa.solution)
            }
            (qa.subQuestionList || []).forEach(sub => {
                if (sub.solution) {
                    sub.solution = Base64.decode(sub.solution)
                }
            })
        })
    }
    return r1
}

// 单题保存接口
export function saveQua(data) {
    let reqData = JSON.parse(JSON.stringify(data))
    if (reqData.solution) {
        reqData.solution = Base64.encode(reqData.solution) // 全部加码
    }
    if (reqData.subQuestionList?.length) {
        reqData.subQuestionList.forEach(sub => {
            if (sub.solution) {
                sub.solution = Base64.encode(sub.solution) // 全部加码
            }
        })
    }
    return request({
        url: `/system/exam/submitQuestion`,
        method: 'post',
        data: reqData
    })
}

// 保存切题记录
export function saveToggleRecord(id) {
    return request({
        url: `/system/exam/switchQuestion?examStudentInfoId=${id}`,
        method: 'post',
    })
}

// 交卷验证题目是否全部做完接口
export function checkSubmitPaper(data) {
    return request({
        url: `/system/exam/checkNotAnsweredQuestion`,
        method: 'post',
        params: data
    })
}

// 交卷接口
export function submitPaper(data) {
    return request({
        url: `/system/exam/endExam`,
        method: 'post',
        data
    })
}

//腾讯云播放鉴权
export function findTxPlayerInfo(data) {
    return request({
        url: `/system/api/play/getPlayToken`,
        method: 'post',
        params: data
    })
}

// 开始考试、补考前校验接口
export function checkExam(examId) {
    return request({
        url: `/system/exam/checkFinalExamCount?examId=${examId}`,
        method: 'post',
    })
}

// 查询常规考试题统计
export function findExamStatistNormal(id) {
    return request({
        url: `/system/exam/examReport?examStudentInfoId=${id}`,
        method: 'get',
    })
}


// 三个作业、模拟考试 添加考试和参考学员
export function threeAssignmentAndSimulatedExamApi() {
    return request({
        url: `/system/exam/threeAssignmentAndSimulatedExam/join`,
        method: 'get',
    })
}

// 根据教学目标id获取随堂练习信息
export function getInClassExercisesPaperVoApi(objectivesId) {
    return request({
        url: `/system/study/center/chapter/getInClassExercisesPaperVo/${objectivesId}`,
        method: 'get',
    })
}

// 获取课程分类，课程名称
export function classifyAndSubjectList(examType) {
    return request({
        url: `/system/workExam/info/classifyAndSubjectList?examType=${examType}`,
        method: 'get',
    })
}


// 查询考试--参考答案解析列表
export async function findExamPreview(data) {
    const r1 = await request({
        url: `/system/examPaper/preview`,
        method: 'post',
        data
    })
    if (r1.data?.examQuestionsVo?.length) {
        r1.data.examQuestionsVo.forEach(qa => {
            if (qa.solution) {
                qa.solution = Base64.decode(qa.solution)
            }
            (qa.subQuestionList || []).forEach(sub => {
                if (sub.solution) {
                    sub.solution = Base64.decode(sub.solution)
                }
            })
        })
    }
    return r1
}


// 做账试卷（财略） 评分是否评完了
export function checkIsScoreFinish(examStuInfoId) {
  return request({
    url: `/system/exam/scoreStatus?examStudentInfoId=${examStuInfoId}`,
    method: 'get',
  })
}

// 做账试卷（财略） 解析页查询
export function findAccountPaperAnalysis(examStuInfoId) {
  return request({
    url: `/system/examStuDetail/${examStuInfoId}`,
    method: 'get',
  })
}

// 岗前测试---分页列表
export async function findPreJobList(data) {
    const r1 = await request({
        url: `/system/my/employment/pre/test/big/exam/page`,
        method: 'get',
        params: data
    })
    const r2 = await request({
        url: `/system/examPaper/percentageStatistics?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
        method: 'post',
        data: {
            ...data,
            typeList: ['岗前测试'],
        }
    })
    return [r1, r2]


}

// 岗前测试---子考试列表查询
export function findSubPreJobList(params) {
    return request({
        url: `/system/my/employment/pre/test/sub/exam/page`,
        method: 'get',
        params
    })
}

// 岗前测试--校验接口
export function checkPreJob(params) {
    return request({
        url: `/system/my/employment/pre/test/prepareExam`,
        method: 'get',
        params
    })
}


// 岗前测试---开始做题
export function startPreJob(params) {
    return request({
        url: `/system/my/employment/pre/test/preBeginExam`,
        method: 'get',
        params
    })
}
